export default __webpack_public_path__ + "static/media/causal-clustering-drivers.c74c90d1.svg";